import { render, staticRenderFns } from "./HomeNameWeek.vue?vue&type=template&id=587820d6&scoped=true"
import script from "./HomeNameWeek.vue?vue&type=script&lang=js"
export * from "./HomeNameWeek.vue?vue&type=script&lang=js"
import style0 from "./HomeNameWeek.vue?vue&type=style&index=0&id=587820d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587820d6",
  null
  
)

export default component.exports